import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./section1";
import Section2 from "./section2";
import Section3 from "./section3";
import Section4 from "./section4";
import Section5 from "./section5";

export default function career() {
  return (
    <div className="leading-7 Career pt-[160px] sm:pt-0">
      <Helmet>
        <title>Career - Mean3 Software Solutions</title>
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
    </div>
  );
}
